import { httpClient } from '@/api/httpClient';
import type { BillingOnboarding, BillingRedirectResponse, BillingStatus } from '../types/billing';

export const billingApi = {
  getOnboarding() {
    return httpClient<BillingOnboarding>('/api/v1/billing/onboarding/');
  },
  getSubscription() {
    return httpClient<BillingStatus>('/api/v1/billing/subscription/');
  },
  createCheckoutSession(input: { plan_code?: string; success_url: string; cancel_url: string }) {
    return httpClient<BillingRedirectResponse>('/api/v1/billing/checkout/', {
      method: 'POST',
      body: JSON.stringify(input)
    });
  },
  createCustomerPortalSession(input: { return_url: string }) {
    return httpClient<BillingRedirectResponse>('/api/v1/billing/customer-portal/', {
      method: 'POST',
      body: JSON.stringify(input)
    });
  }
};
